<template>
	<div class="single-flex-row">
		<div class="right-td mh-days">
			<p class="right-td">
				<i class="right-td-i">{{result.totalWorkingDays}}</i>
			</p>
		</div>
		<div class="right-td mh-vac">
			<p class="right-td">
				<i class="right-td-i">{{result.vacations}}</i>
			</p>
		</div>
		<div class="right-td mh-sick">
			<p class="right-td">
				<i class="right-td-i">{{result.sick}}</i>
			</p>
		</div>
		<div class="right-td mh-other">
			<p class="right-td">
				<i class="right-td-i">{{result.other}}</i>
			</p>
		</div>
		<div class="right-td mh-not-yet-approved-holiday">
			<p class="right-td">
				<i class="right-td-i">{{result.notYetApprovedHoliday}}</i>
			</p>
		</div>
		<div class="right-td note-t mh-act">
			<p class="right-td">
				<i class="right-td-i">{{result.actualWorkingDays}}</i>
			</p>
		</div>
		<div class="right-td mh-note"></div>
		<div class="right-td tv">
			<p class="right-td">
				<i
					v-tooltip.top-start="$options.filters.money(result.turnOver)+'€'"
				>{{result.turnOver | money | truncate(9)}} €</i>
			</p>
		</div>
	</div>
</template>

<script>
import filters from "../../../../mixins/filters";

export default {
  name: "ResultRow",
  props: ["result"],
  mixins: [filters]
};
</script>

<style scoped>
	.month-report-bottom-inner .month-table td.right-td {
		padding: 8.5px 0 !important;
	}

	.month-report-bottom-inner .month-table td.right-td .right-td {
		line-height: 23.48px;
		margin-bottom: 0 !important;
	}

	.month-report-bottom-inner .month-table tr:first-of-type td.right-td {
		padding-top: 16px !important;
	}
</style>
